import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookiePolicyPage = () => {
  return (
    <div className="bg-revo-bg pt-20 min-h-screen">
      {/* Hero */}
      <section className="py-16 md:py-24 border-b border-revo-border">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="font-manrope text-sm text-revo-orange uppercase tracking-widest">
              Informativa sui Cookie
            </span>
            <h1 className="font-barlow text-4xl md:text-5xl font-bold uppercase tracking-tight text-white mt-4">
              Cookie Policy
            </h1>
            <p className="font-manrope text-gray-400 mt-4">
              Ultimo aggiornamento: Gennaio 2024
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-invert max-w-none
            prose-headings:font-barlow prose-headings:uppercase prose-headings:tracking-tight
            prose-h2:text-2xl prose-h2:text-white prose-h2:mt-12 prose-h2:mb-4 prose-h2:border-b prose-h2:border-revo-border prose-h2:pb-4
            prose-h3:text-lg prose-h3:text-revo-orange prose-h3:mt-8 prose-h3:mb-3
            prose-p:font-manrope prose-p:text-gray-400 prose-p:leading-relaxed
            prose-ul:font-manrope prose-ul:text-gray-400
            prose-li:marker:text-revo-orange
            prose-strong:text-white
            prose-table:border-collapse
            prose-th:bg-revo-paper prose-th:text-white prose-th:font-barlow prose-th:uppercase prose-th:p-4 prose-th:text-left prose-th:border prose-th:border-revo-border
            prose-td:p-4 prose-td:border prose-td:border-revo-border"
          >
            <h2>1. Cosa sono i Cookie</h2>
            <p>
              I cookie sono piccoli file di testo che i siti web visitati inviano al browser dell'utente, 
              dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. 
              I cookie permettono ai siti web di funzionare correttamente e di raccogliere informazioni 
              sulle preferenze degli utenti.
            </p>

            <h2>2. Titolare del Trattamento</h2>
            <p>
              <strong>Revogreen srl</strong><br />
              Via Alberto Dominutti, 6<br />
              37135 Verona (VR)<br />
              P.IVA: 05121010234<br />
              Email: privacy@revoquota.com
            </p>

            <h2>3. Tipologie di Cookie Utilizzati</h2>

            <h3>3.1 Cookie Tecnici (Essenziali)</h3>
            <p>
              Sono cookie necessari per il corretto funzionamento del sito web. Non raccolgono 
              informazioni personali identificabili e non possono essere disabilitati.
            </p>
            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Finalità</th>
                  <th>Durata</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>revo_cookie_consent</td>
                  <td>Memorizza la preferenza sui cookie</td>
                  <td>1 anno</td>
                </tr>
                <tr>
                  <td>session_id</td>
                  <td>Gestione della sessione utente</td>
                  <td>Sessione</td>
                </tr>
              </tbody>
            </table>

            <h3>3.2 Cookie Analitici</h3>
            <p>
              Sono cookie che raccolgono informazioni aggregate sul modo in cui gli utenti 
              utilizzano il sito web. Questi dati sono utilizzati per migliorare il sito 
              e l'esperienza utente.
            </p>
            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Fornitore</th>
                  <th>Finalità</th>
                  <th>Durata</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>_ga</td>
                  <td>Google Analytics</td>
                  <td>Distingue gli utenti</td>
                  <td>2 anni</td>
                </tr>
                <tr>
                  <td>_gid</td>
                  <td>Google Analytics</td>
                  <td>Distingue gli utenti</td>
                  <td>24 ore</td>
                </tr>
                <tr>
                  <td>_gat</td>
                  <td>Google Analytics</td>
                  <td>Limita le richieste</td>
                  <td>1 minuto</td>
                </tr>
              </tbody>
            </table>

            <h2>4. Come Gestire i Cookie</h2>
            <p>
              L'utente può gestire le proprie preferenze sui cookie in diversi modi:
            </p>

            <h3>4.1 Tramite il nostro Banner</h3>
            <p>
              Alla prima visita del sito, viene mostrato un banner che permette di accettare 
              tutti i cookie o solo quelli essenziali. È possibile modificare le preferenze 
              in qualsiasi momento cliccando sul link "Gestione Cookie" nel footer.
            </p>

            <h3>4.2 Tramite le Impostazioni del Browser</h3>
            <p>
              È possibile gestire i cookie anche attraverso le impostazioni del proprio browser:
            </p>
            <ul>
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-revo-orange hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-revo-orange hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-revo-orange hover:underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-revo-orange hover:underline">Microsoft Edge</a></li>
            </ul>

            <h2>5. Cookie di Terze Parti</h2>
            <p>
              Questo sito potrebbe utilizzare servizi di terze parti che installano cookie 
              per il loro funzionamento. Di seguito i link alle relative informative:
            </p>
            <ul>
              <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-revo-orange hover:underline">Google Analytics - Privacy Policy</a></li>
            </ul>

            <h2>6. Conseguenze della Disabilitazione</h2>
            <p>
              La disabilitazione dei cookie tecnici può compromettere il corretto funzionamento 
              del sito. La disabilitazione dei cookie analitici non influisce sulla navigazione 
              ma impedisce di raccogliere dati anonimi per migliorare il servizio.
            </p>

            <h2>7. Modifiche alla Cookie Policy</h2>
            <p>
              Il Titolare si riserva il diritto di apportare modifiche alla presente Cookie Policy 
              in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina.
            </p>

            <h2>8. Riferimenti Normativi</h2>
            <ul>
              <li>Regolamento UE 2016/679 (GDPR)</li>
              <li>D.Lgs. 196/2003 (Codice Privacy) come modificato dal D.Lgs. 101/2018</li>
              <li>Provvedimento del Garante Privacy del 10 giugno 2021</li>
              <li>Direttiva 2009/136/CE (Cookie Law)</li>
            </ul>

            <h2>9. Contatti</h2>
            <p>
              Per qualsiasi informazione relativa ai cookie utilizzati da questo sito, 
              è possibile contattare:
            </p>
            <p>
              <strong>Revogreen srl</strong><br />
              Email: privacy@revoquota.com<br />
              Tel: +39 045 000 0000
            </p>

            <div className="mt-12 p-6 bg-revo-paper border border-revo-border">
              <p className="text-gray-300 mb-4">
                Per maggiori informazioni sul trattamento dei tuoi dati personali, consulta la nostra:
              </p>
              <Link 
                to="/privacy" 
                className="inline-flex items-center gap-2 text-revo-orange hover:underline"
              >
                Privacy Policy completa →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
